interface PastSlotOverlayProps {
  rounded?: string;
  fine?: boolean;
}

export function PastSlotOverlay({ rounded = '', fine = false }: PastSlotOverlayProps) {
  return (
    <div
      className={`past-slot-hatch pointer-events-none absolute inset-0 z-[4] ${fine ? 'past-slot-hatch--fine' : ''} ${rounded}`}
      aria-hidden
    />
  );
}
